import React from 'react';
import classnames from 'classnames';
import styles from './button.module.scss';

const Button = ({ isLink = false, children, className, color, ...rest }) => (
  isLink ? (
    <a
      className={classnames(styles.button, className, {
        [styles.transparent]: color === 'transparent',
        [styles.lightgray]: color === 'lightgray',
      })}
      {...rest}
    >
      {children}
    </a>
  ) : (
    <button
      type="button"
      className={classnames(styles.button, className, {
        [styles.transparent]: color === 'transparent',
        [styles.lightgray]: color === 'lightgray',
      })}
      {...rest}
    >
      {children}
    </button>
  )
);

export default Button;
